/* eslint-disable perfectionist/sort-objects */
import React, {FC, useState} from 'react';

import {Modal, zIndex} from '@optimaxdev/design-system';
import {Icon, Exit} from '@optimaxdev/icons';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';

import dryEye from '../pdpLensesBenefits/img/dryEye.svg?url';
import hyaluronic from '../pdpLensesBenefits/img/hyaluronic.svg?url';
import innovative from '../pdpLensesBenefits/img/innovative.svg?url';
import uv from '../pdpLensesBenefits/img/uv.svg?url';

import s from './giftPopup.scss';

const modalOptions = {
    blank: true,
    options: {
        withBorderRadius: false,
    },
    overlay: 'dark' as const,
    withoutCloses: true,
    zIndex: zIndex.popup,
};

const BENEFITS = [
    {
        icon: innovative,
        name: 'Support your lifestyle',
        description:
            'An innovative lens that provides comfort for both indoor and outdoor activities.',
    },
    {
        icon: hyaluronic,
        name: 'Healthy eye care',
        description:
            'The hygenic choice with Hyaluronic Acid for maximum moisture & all-day hydration.',
    },
    {
        icon: uv,
        name: 'UV protection',
        description:
            'With a Class 2 classification, protect against UV radiation to the cornea and into the eye',
    },
    {
        icon: dryEye,
        name: 'Reduce digital eye strain',
        description: 'Reduce irritation and redness caused by dry eyes and extended screen time.',
    },
];

/**
 * "Learn more" popup for Vista Gift item on the cart
 *  @returns {React.ReactElement} - rendered component
 */
export const GiftPopup: FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button className={s.learnMore} onClick={() => setIsOpen(true)} type="button">
                Learn more
            </button>
            <Modal isOpen={isOpen} {...modalOptions}>
                <section className={s.container}>
                    <header className={s.header}>
                        <div className={s.headerInformation}>
                            <h1 className={s.title}>
                                Finally a daily contact lens designed for your dynamic lifestyle.
                            </h1>
                            <p className={s.description}>
                                Vista plus with Hyaluronic Acid for moisture and lubrication,
                                ensures all day comfort whether you’re out in the elements, or
                                inside behind a screen.
                            </p>
                        </div>
                    </header>
                    <div className={s.benefits}>
                        <ul className={s.benefitsList}>
                            {BENEFITS.map(({description, icon, name}) => (
                                <li className={s.benefit} key={name}>
                                    <CloudinaryImage className={s.benefitIcon} src={icon} />
                                    <h3 className={s.benefitName}>{name}</h3>
                                    <p>{description}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <button
                        aria-label="Close modal"
                        className={s.closeBtn}
                        onClick={() => setIsOpen(false)}
                        type="button"
                    >
                        <Icon icon={Exit} size="small" />
                    </button>
                </section>
            </Modal>
        </>
    );
};
